import Folder from 'repos/Folder.js';
import {ipfsHashToBytes32, bytes32ToIPFSHash} from 'utils/ipfsHash.js';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {FOLDERS} from 'decentralized/transactions/contracts.js';
import FoldersContract from 'decentralized/contracts/FoldersContract.js';
import {FoldersUpdated} from 'decentralized/EthereumEvents.js';
import Preset from 'repos/Preset.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import ipfs from 'decentralized/Ipfs.js';

const contract = new FoldersContract();

/**
 * Handles interfaces between ethereum folder sub contract and 
 * storing the state of the folder here. Syncing and others etc
 */
class Folders {
    constructor(web3) {
        this.web3 = web3;
        this.root = new Folder();
        this.contract = contract.getContract(web3);
        this.contractAddress = contract.contractAddress;
        this.isLoaded = false;
    }

    syncFolders() {
        return new Promise(async (resolve, reject) => {
            let json = this.root.getJson();
            let hash = await ipfs.addJson(json);
            
            new EthereumTransaction(
                FOLDERS,
                'foldersUpdated',
                [ipfsHashToBytes32(hash)])
                .execute()
                .then(s => resolve());
        });
    }

    async loadFolders() {
        let query = new BackendQuery(this.contractAddress)
            .from(FoldersUpdated)
            .select('foldersHash');

        let results = await query.executeQuery();

        if (results.length === 0) {
            return;
        }

        let foldersHash = results[0].foldersHash;
        let foldersJson = await ipfs.getJson(foldersHash);

        this.root.fromJson(
            foldersJson,
            (json) => new Preset().fromJson(json));

        this.isLoaded = true;
    }
}

export default Folders;
